import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FTPService from '~/api/services/ftp';
import Layout from '~/components/Layout';
import notify from '~/components/Notify';
import FTPCard from './FTPCard';
import { Message } from 'semantic-ui-react';

const FTP: React.FunctionComponent = () => {
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)
  const [options, setOptions] = useState(null)
  const [activeFtp, setActiveFtp] = useState(-1)

  const { handleSubmit, control, reset, getValues, setValue, watch } = useForm({
    mode: 'onSubmit'
  })

  useEffect(() => {
    fetchData()
  }, [t])

  async function fetchData() {
    setIsBusy(false)
    try {
      const responseOptions = await FTPService.getFtpOptions()
      if (Object.keys(getValues()).length === 0) {
        const responseData = await FTPService.getFtpData()
        responseData.data.ftps.forEach(ftp => {
          ftp.notificationEmails = ftp.notificationEmails.map(email => ({ email: email }))
        })
        reset(responseData.data)
      }
      setOptions(responseOptions.data)
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      data.ftps?.forEach(ftp => {
        ftp.notificationEmails = ftp.notificationEmails.map((notificationEmail) => notificationEmail.email)
      })
      await FTPService.updateFtps(data)
      notify(t('Successfully updated ftp settings'), 'success')
    } catch (error) {
      if (error.response?.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
    setIsBusy(false)
  }

  function handleRecipientsHeaderClick(e, titleProps) {
    const { index } = titleProps;
    setActiveFtp(activeFtp === index ? -1 : index);
  }

  function renderNoFtpsMessage() {
    return !isBusy && <Message info style={{ margin: '20px auto', textAlign: 'center', maxHeight: 70, width: '50%' }}>
      <Message.Header>{t('No results')}</Message.Header>
      <p>{t('Sorry, there are no ftps to display.')}</p>
    </Message>
  }

  function renderFtps() {
    const ftps = getValues('ftps') || []
    return <>
      {ftps?.length === 0 ? renderNoFtpsMessage() : ftps.map((ftp, index) => {
        const active = activeFtp === index
        const watchScheduledActiveField = watch(`ftps[${index}].schedulerActive`)
        return <FTPCard
          key={ftp.label}
          watchScheduledActiveField={watchScheduledActiveField}
          ftp={ftp}
          index={index}
          active={active}
          handleRecipientsHeaderClick={handleRecipientsHeaderClick}
          control={control}
          options={options}
          getValues={getValues}
          setValue={setValue}
        />
      })}
    </>
  }

  return <Layout
    segmented
    title={t('FTP settings')}
    action={t('Update')}
    isBusy={isBusy}
    onSubmit={handleSubmit(onSubmit)}
  >
    {options && renderFtps()}
  </Layout>
};
export default FTP;
